module.exports = __webpack_public_path__ + "media/assets/icons/reflection-cover-background-42288c2c06d95a6c837b29af928b4f94.svg";